export default "__VITE_PUBLIC_ASSET__e9477a69__"